import React, { useState } from 'react'
import { img } from '../assets/assets'

const Roadmap = () => {
    const [showPhase, setShowPhase] = useState('firstPhase')
    const [showMobileMenu, setShowMobileMenu] = useState(false)
    return (
        <>
            <div className="overflow-hidden">
                {/* <!-- <div className="bg-dark py-10">
            <div className="container">
                <div
                    className="text-center
                    d-flex
                    justify-content-between
                    space-x-10
                    align-items-center">
                    <div className="space-x-10 d-flex align-items-center">
                        <lottie-player
                            src="https://assets6.lottiefiles.com/private_files/lf30_kqshlcsx.json"
                            background="transparent"
                            speed="2"
                            style="width: 50px; height: 50px"
                            loop
                            autoplay></lottie-player>
                        <p className="color_white">
                            Dark mode is now
                            <span style="color: rgb(0, 255, 170)">Available </span>
                        </p>
                    </div>

                    <div className="mode_switcher space-x-10">
                        <a href="#" className="light d-flex align-items-center is_active">
                            <i className="ri-sun-fill"></i> Light
                        </a>
                        <a href="#" className="dark d-flex align-items-center">
                            <i className="ri-moon-fill"></i> Dark
                        </a>
                    </div>
                </div>
            </div>
        </div> --> */}

                <header className="header__1 js-header" id="header">
                    <div className="container">
                        <div className="wrap js-header-wrapper">
                            <div className="header__logo">
                                <a className="color_black" href="/">
                                    <img
                                        src={img.logos_seducetoken}
                                        alt="logo"
                                        id="logo_js_f"
                                    />
                                </a>
                            </div>

                            {/* <!-- ==================  --> */}
                            <div className="header__menu">
                                <ul className="d-flex space-x-20">
                                    <li className="has_popup">
                                        <a className="color_black" href="/">
                                            Home
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/about"
                                        >
                                            About Us
                                        </a>
                                    </li>
                                    <li>
                                        <a className="color_black" href="/team">
                                            Our Team
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/roadmap"
                                        >
                                            Roadmap
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href={img.whitepaper}
                                        >
                                            Whitepaper
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/ambassador"
                                        >
                                            Ambassadors
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/contact"
                                        >
                                            Contact
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            {/* <!-- ================= --> */}
                            <div className="header__btns">
                                <a
                                    className="btn btn-grad btn-sm"
                                    href="/dashboard"
                                >
                                    <img
                                        src={img.icons_settings}
                                        alt="Dashboard"
                                        height="20px"
                                        width="20px"
                                    />
                                    Dashboard
                                </a>
                            </div>

                            <div
                                className="header__burger js-header-burger"
                                onClick={() =>
                                    setShowMobileMenu(!showMobileMenu)
                                }
                            ></div>
                            {showMobileMenu ? (
                                <div className="header__mobile js-header-mobile">
                                    <div className="header__mobile__menu space-y-40">
                                        <ul className="d-flex space-y-20">
                                            <li className="has_popup">
                                                <a
                                                    className="color_black"
                                                    href="/"
                                                >
                                                    Home
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/about"
                                                >
                                                    About Us
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/team"
                                                >
                                                    Our Team
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/roadmap"
                                                >
                                                    Roadmap
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href={img.whitepaper}
                                                >
                                                    Whitepaper
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/ambassador"
                                                >
                                                    Ambassadors
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/contact"
                                                >
                                                    Contact
                                                </a>
                                            </li>
                                        </ul>
                                        <div className="space-y-20">
                                            <a
                                                className="btn btn-grad btn-sm"
                                                href="/dashboard"
                                            >
                                                Dashboard
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                </header>

                <div className="container">
                    <a href="/" className="btn btn-white btn-sm my-40">
                        Back to home
                    </a>
                    <div className="item_details">
                        <div className="row sm:space-y-20">
                            <div className="col-lg-6">
                                <img
                                    className="item_img"
                                    src={img.logos_roadmap}
                                    alt=""
                                />
                            </div>
                            <div className="col-lg-6">
                                <div className="space-y-20">
                                    <h2>Roadmap.</h2>
                                    <div className="box">
                                        <div className="space-y-20">
                                            <div
                                                className="d-flex justify-content-between
                                        mb-30_reset"
                                            >
                                                <ul
                                                    className="nav nav-tabs d-flex space-x-10 mb-30"
                                                    role="tablist"
                                                >
                                                    <li
                                                        className="nav-item"
                                                        onClick={() =>
                                                            setShowPhase(
                                                                'firstPhase'
                                                            )
                                                        }
                                                    >
                                                        <a
                                                            className={`${
                                                                showPhase ===
                                                                'firstPhase'
                                                                    ? 'active'
                                                                    : ''
                                                            }
                                                                      btn btn-white btn-sm`}
                                                            data-toggle="tab"
                                                            href="#tabs-1"
                                                            role="tab"
                                                        >
                                                            Phase 1
                                                        </a>
                                                    </li>
                                                    <li
                                                        className="nav-item"
                                                        onClick={() =>
                                                            setShowPhase(
                                                                'secondPhase'
                                                            )
                                                        }
                                                    >
                                                        <a
                                                            className={`${
                                                                showPhase ===
                                                                'secondPhase'
                                                                    ? 'active'
                                                                    : ''
                                                            }
          btn btn-white btn-sm`}
                                                            data-toggle="tab"
                                                            href="#tabs-2"
                                                            role="tab"
                                                        >
                                                            Phase 2
                                                        </a>
                                                    </li>
                                                    <li
                                                        className="nav-item"
                                                        onClick={() =>
                                                            setShowPhase(
                                                                'thirdPhase'
                                                            )
                                                        }
                                                    >
                                                        <a
                                                            className={`${
                                                                showPhase ===
                                                                'thirdPhase'
                                                                    ? 'active'
                                                                    : ''
                                                            }
          btn btn-white btn-sm`}
                                                            data-toggle="tab"
                                                            href="#tabs-3"
                                                            role="tab"
                                                        >
                                                            Phase 3
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="hr"></div>
                                            <div className="tab-content">
                                                {showPhase === 'firstPhase' && (
                                                    <div
                                                        className={
                                                            showPhase ===
                                                            'firstPhase'
                                                                ? 'active'
                                                                : '' +
                                                                  'tab-pane space-y-20'
                                                        }
                                                        id="tabs-1"
                                                        role="tabpanel"
                                                    >
                                                        <div
                                                            className="creator_item
                                                space-x-10"
                                                        >
                                                            <div className="avatars space-x-10">
                                                                <div>
                                                                    <p className="color_black">
                                                                        <b>
                                                                            Phase
                                                                            1
                                                                        </b>
                                                                    </p>
                                                                    <span className="date color_text">
                                                                        ‣
                                                                        Strategies
                                                                        and
                                                                        Planning.
                                                                        <br />
                                                                        ‣
                                                                        Website
                                                                        launch
                                                                        aided by
                                                                        the
                                                                        whitepaper.
                                                                        <br />
                                                                        ‣ Point
                                                                        3 ‣
                                                                        Inception
                                                                        of the
                                                                        telegram
                                                                        community.
                                                                        <br />
                                                                        ‣
                                                                        Orchestration
                                                                        of
                                                                        shilling
                                                                        contest
                                                                        for
                                                                        whitelist.
                                                                        <br />
                                                                        ‣ Launch
                                                                        of the
                                                                        social
                                                                        media
                                                                        handles
                                                                        (Twitter,
                                                                        and
                                                                        Instagram).
                                                                        <br />
                                                                        ‣
                                                                        Audit(Tech
                                                                        Rate,
                                                                        Rugfreecoins
                                                                        and
                                                                        application
                                                                        for
                                                                        certik).
                                                                        <br />
                                                                        ‣
                                                                        Giveaways.
                                                                        <br />
                                                                        ‣
                                                                        Private
                                                                        presale
                                                                        with
                                                                        small
                                                                        hardcap
                                                                        promotions
                                                                        within
                                                                        cyrpto
                                                                        communities.
                                                                        <br />
                                                                        ‣
                                                                        Onboard
                                                                        influencers.
                                                                        <br />
                                                                        ‣ AMAs
                                                                        <br />‣
                                                                        Presale.
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {showPhase ===
                                                    'secondPhase' && (
                                                    <div
                                                        className={
                                                            showPhase ===
                                                            'secondPhase'
                                                                ? 'active'
                                                                : '' +
                                                                  'tab-pane space-y-20'
                                                        }
                                                        id="tabs-2"
                                                        role="tabpanel"
                                                    >
                                                        <div
                                                            className="creator_item 
                                                space-x-10"
                                                        >
                                                            <div className="avatars space-x-10">
                                                                <div>
                                                                    <p className="color_black">
                                                                        <b>
                                                                            Phase
                                                                            2
                                                                        </b>
                                                                    </p>
                                                                    <span className="date color_text">
                                                                        ‣ Major
                                                                        marketing
                                                                        &
                                                                        advertising
                                                                        using
                                                                        funds
                                                                        from
                                                                        presales.
                                                                        <br />
                                                                        ‣
                                                                        Pancakeswap
                                                                        Launch.
                                                                        <br />
                                                                        ‣ Coin
                                                                        market
                                                                        cap &
                                                                        coin
                                                                        gecko
                                                                        listings.
                                                                        <br />
                                                                        ‣ Trip
                                                                        sponsorship
                                                                        to LA
                                                                        (Lucky
                                                                        winners
                                                                        among
                                                                        the top
                                                                        100
                                                                        buyers).
                                                                        <br />
                                                                        ‣ NFT
                                                                        Airdrops
                                                                        to
                                                                        contest
                                                                        winners.
                                                                        <br />
                                                                        ‣
                                                                        Singing
                                                                        in adult
                                                                        content
                                                                        creators
                                                                        and
                                                                        pornstars.
                                                                        <br />
                                                                        ‣ Press
                                                                        Releases.
                                                                        <br />
                                                                        ‣ Beta
                                                                        Version
                                                                        Testing.
                                                                        <br />
                                                                        ‣
                                                                        Application
                                                                        for CEX
                                                                        listing.
                                                                        <br />‣
                                                                        Augment
                                                                        Marketing
                                                                        Activations
                                                                        Through
                                                                        Associations
                                                                        with
                                                                        established
                                                                        companies
                                                                        within
                                                                        the
                                                                        industry.
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {showPhase === 'thirdPhase' && (
                                                    <div
                                                        className={
                                                            showPhase ===
                                                            'thirdPhase'
                                                                ? 'active'
                                                                : '' +
                                                                  'tab-pane space-y-20'
                                                        }
                                                        id="tabs-3"
                                                        role="tabpanel"
                                                    >
                                                        <div
                                                            className="creator_item 
                                                space-x-10"
                                                        >
                                                            <div className="avatars space-x-10">
                                                                <div>
                                                                    <p className="color_black">
                                                                        <b>
                                                                            Phase
                                                                            3
                                                                        </b>
                                                                    </p>
                                                                    <span className="date color_text">
                                                                        ‣
                                                                        Rebranding.
                                                                        <br />
                                                                        ‣ CEX
                                                                        Listing.
                                                                        <br />
                                                                        ‣ App
                                                                        launch.
                                                                        <br />
                                                                        ‣
                                                                        Platform
                                                                        Launch.
                                                                        <br />
                                                                        ‣
                                                                        Business
                                                                        Expansions.
                                                                        <br />
                                                                        ‣
                                                                        Tie-ups
                                                                        and
                                                                        associates.
                                                                        <br />
                                                                        ‣ Major
                                                                        CEX
                                                                        listings.
                                                                        <br />
                                                                        ‣ Major
                                                                        News
                                                                        Coverage.
                                                                        <br />‣
                                                                        Billboard
                                                                        Ads.
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="footer__1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 space-y-20">
                                <div className="footer__logo">
                                    <a href="/">
                                        <img
                                            src={img.logos_seducetoken}
                                            alt="logo"
                                            id="logo_js_f"
                                        />
                                    </a>
                                </div>

                                <div>
                                    <ul className="footer__social space-x-10 mb-40">
                                        <li>
                                            <a href="https://instagram.com/seduce_token_official?utm_medium=copy_link">
                                                <i className="ri-instagram-line"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://twitter.com/seducetokenbsc">
                                                <i className="ri-twitter-line"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://discord.gg/ewekBsfU4B">
                                                <i className="ri-discord-line"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://t.me/seducetokenofficial">
                                                <i className="ri-telegram-line"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Project</h6>
                                <ul className="footer__list">
                                    <li>
                                        <a href="/"> Home </a>
                                    </li>
                                    <li>
                                        <a href="/about">About us</a>
                                    </li>
                                    <li>
                                        <a href="/team"> Our Team</a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/roadmap"
                                        >
                                            Roadmap
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/ambassador">Ambassadors</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Get help</h6>
                                <ul className="footer__list">
                                    <li>
                                        <a href="/contact">Contact Us</a>
                                    </li>
                                    <li>
                                        <a href="/dashboard" target="_blank">
                                            Buy Token
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Documents</h6>
                                <ul className="footer__list">
                                    <li>
                                        <a
                                            href={img.whitepaper}
                                            target="_blank"
                                            rel='noreferrer'
                                        >
                                            Whitepaper
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <p className="copyright text-center">
                            © Seduce Token 2021. Created with love by
                            <a
                                href="https://theclusterco.com"
                                target="_blank"
                                rel="noreferrer"
                            >
                                TheCluster
                            </a>
                            .
                        </p>
                    </div>
                </footer>
            </div>
        </>
    )
}

export default Roadmap
